import React from 'react';
import cns from 'classnames';

import VerbText from '../../../shared/components/VerbText';

export default function NavIcon(props) {
    const { textId, iconClass, isSelected, hiddenXS = true, defaultMessage } = props;
    const translatedText = <VerbText messageId={textId} defaultMessage={defaultMessage} />;
    const navText = textId ? (
        <small key={textId} className={'navbar-section-title'}>
            {translatedText}
        </small>
    ) : null;
    return [
        <span
            key={iconClass}
            className={cns(`navbar-icon fal fa-fw ${iconClass}`, { selected: isSelected }, { 'hidden-xs': hiddenXS })}
        />,
        navText
    ];
}
